import {Component, HostBinding, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ProfilService} from "../profil.service";

/**
 * Composant d'affichage de la déclaration d'accessibilité
 */
@Component({
    selector: 'profil-accessibilite',
    templateUrl: './profil-accessibilite.component.html',
    styleUrls: ['./profil-accessibilite.component.scss']
})
export class ProfilAccessibiliteComponent implements OnInit {
    //Attribut utilise uniquement pour les tests automatises (data-test-id sur le host du composant)
    //Utilisation de HostBinding pour eviter les warnings de l'Angular Language Service
    @HostBinding('attr.data-test-id')
    public dataTestId: string = 'profil-accessibilite';

    /** HTML de la déclaration d'accessibilité */
    public accessibiliteHtml: SafeHtml;

    constructor(private profilService: ProfilService, private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.profilService.getDeclarationAccessibiliteHTML().subscribe(res => {
            //Bypass de la sanitization Angular pour conserver les attributs id et name (le HTML provient du serveur, pas d'un utilisateur)
            this.accessibiliteHtml = this.sanitizer.bypassSecurityTrustHtml(res?.data?.accessibiliteHtml || '');
        });
    }

    /**
     * Intercepte les clics sur les liens d'ancrage (#sectionX) pour empêcher
     * le routeur Angular de naviguer et scroller vers la section ciblée.
     */
    public onInnerHtmlClick(event: MouseEvent): void {
        //Recherche du lien <a> cliqué
        const target = event.target as HTMLElement;
        const anchor = target?.closest ? target.closest('a') as HTMLAnchorElement : null;
        if (!anchor) {
            return;
        }

        //Récupère la valeur de l'attribut href du lien cliqué
        const href = anchor.getAttribute('href');
        //Ne traite que les liens d'ancrage internes (ex: "#section")
        //Si href est absent ou ne commence pas par '#', on ne fait rien (lien classique/externe)
        if (!href || !href.startsWith('#')) {
            return;
        }

        //Empêche le routeur Angular d'intercepter le clic
        event.preventDefault();
        event.stopPropagation();

        //Scroll vers l'élément ciblé par l'ancre
        const anchorId = href.substring(1);
        const element = document.getElementById(anchorId) || document.querySelector('[name="' + anchorId + '"]');
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }
}
